import styled from 'styled-components';

const LogoStyles = styled.img`
	height: 40px;
	&:hover {
		cursor: pointer;
	}
`;

export default LogoStyles;
